import { Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { unit } from '@hcr/pwa/components'

export const BookingListEmpty: FC = () => {
  const { t } = useTranslation()

  return (
    <Typography variant='bodyM' paddingX={unit(5)}>
      {t('home.no-bookings')}
    </Typography>
  )
}
